module.exports = __webpack_public_path__ + "img/plannegocios.3ea4b0eb.svg";